import Helper from './Helper';

class CVTextSameHeight {
  constructor(config = {}) {
    const {
      cvSelector,
    } = config;

    this.selector = cvSelector;
    this.cvs = document.querySelectorAll(cvSelector);
    this.rowOffset = -1;
    this.maxHeight = 0;
    this.similarElements = [];

    // if (this.cvs.length > 0) {
      this.checkSimilarHeight(false);
    // }

    window.addEventListener('resize', () => {
      this.checkSimilarHeight(true);
    });
  }

  checkSimilarHeight(resize) {
    if ( resize ) {
      // this.resetHeight('.ns-cv__name');
      this.resetHeight('.ns-cv__position');
    }
    // this.addSimilarHeight('.ns-cv__name');
    this.addSimilarHeight('.ns-cv__position');
  }

  resetHeight(elementClass) {
    document.querySelectorAll(this.selector).forEach(cv => {
      let element = cv.querySelector(elementClass);
      element.style.height = 'auto';
    });
  }

  addSimilarHeight(elementClass) {
    document.querySelectorAll(this.selector).forEach(cv => {
      let element = cv.querySelector(elementClass);

      let offset = this.getElementOffset(element);
      let height = element.offsetHeight;

      if ( offset.top > this.rowOffset ) {
        this.similarElements.forEach(el => {
          el.style.height = this.maxHeight + 'px';
        });
        this.rowOffset = offset.top;
        this.maxHeight = 0;
        this.similarElements = [];
      }

      if ( height > this.maxHeight ) {
        this.maxHeight = height;
      }

      this.similarElements.push(element);
    });

    this.similarElements.forEach(el => {
      el.style.height = this.maxHeight + 'px';
    });

    this.maxHeight = 0;
    this.rowOffset = -1;
    this.similarElements = [];
  }

  getElementOffset(el) {
    var rect = el.getBoundingClientRect();

    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset,
    };
  }
}

export default CVTextSameHeight;
